import { createApiRef } from "@backstage/core";
import { DiscoveryApi, IdentityApi } from "@backstage/core-plugin-api";
import axios, { AxiosResponse } from "axios";

export const confluenceApiRef = createApiRef<ConfluenceApi>({
  id: "plugin.confluence-api.service",
  description: "Used by plugins to make requests to Confluence",
});

type Options = {
  discoveryApi: DiscoveryApi;
  identityApi: IdentityApi;
};

export class ConfluenceApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;

  constructor(options: Options) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  /** Retrieve the primary URL  */
  private async getUrl(): Promise<string> {
    return await this.discoveryApi.getBaseUrl("confluence-api");
  }

  public async search({
    query,
    limit,
    userId,
  }: {
    query?: string;
    limit?: string;
    userId?: string;
  }): Promise<AxiosResponse<any>> {
    const apiUrl = await this.getUrl();
    let q: string = query || "type=page";

    if (userId) {
      if (query) {
        q = `${query} and creator="${userId}"`;
      } else {
        q = `creator="${userId}"`;
      }
    }

    try {
      const { token } = await this.identityApi.getCredentials();
      const response = await axios.get(
        `${apiUrl}/search?query=${encodeURIComponent(
          q
        )}&limit=${encodeURIComponent(limit || 25)}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response;
    } catch (err: any) {
      throw new Error(
        `status ${err.response.status}: ${err.response.data.message}`
      );
    }
  }
}
